import React from 'react';
import { plata } from '../utils/format';
interface Props {
  total: number;
  unidades: number;
  puedeConfirmar: boolean;
  enviando: boolean;
  onConfirmar: () => void;
}
export function BarraTotal({
  total,
  unidades,
  puedeConfirmar,
  enviando,
  onConfirmar
}: Props) {
  return <div className="fixed inset-x-0 bottom-0 z-20 border-t border-line bg-surface px-[18px] pt-3 shadow-bar safe-bottom lg:hidden" data-id="element-20" data-mp="1ccpphjsl7cl8">
      <div className="mx-auto flex max-w-col items-center gap-3.5" data-id="element-21" data-mp="1qbflsx7l188j">
        <div className="min-w-0 flex-1" data-id="element-22" data-mp="1mb5gznvj0nv9">
          <span className="block text-[11px] font-semibold uppercase tracking-[0.075em] text-ink-faint" data-id="element-23" data-mp="1ma43zduy9raw">
            {unidades > 0 ? `${unidades} artículos` : 'Total'}
          </span>
          <strong className="block font-mono text-[21px] font-bold leading-tight tnum tracking-[-0.02em]" data-id="element-24" data-mp="1v2xpvu4wjoxq">
            {plata(total)}
          </strong>
        </div>
        <button type="button" onClick={onConfirmar} disabled={!puedeConfirmar || enviando} className="display-btn shrink-0 rounded-field bg-accent px-[22px] py-3.5 text-[15.5px] text-accent-ink transition-[background-color,transform] duration-150 ease-soft hover:bg-accent-hover active:translate-y-px disabled:cursor-not-allowed disabled:bg-line-strong disabled:text-surface" data-id="element-25" data-mp="251dhrzbr728a">
          {enviando ? 'Enviando…' : 'Confirmar pedido'}
        </button>
      </div>
    </div>;
}